export default {"src":"/_next/static/media/massage-chair.f65ff7df.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};